import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import ColorSlider from '../ColorSlider/ColorSlider'

const VolumeSlider = React.forwardRef(({ value, ...rest }, ref) => {
  const fallbackRef = useRef(null)
  const values = [
    {
      value,
      color: '#8A0000'
    },
    {
      value: rest.max,
      color: 'rgba(0,0,0,0.5)'
    }
  ]
  const trackStyles = {
    height: 8
  }
  const thumbStyles = {
    width: 16,
    height: 16,
    background: '#8A0000',
    borderRadius: 8
  }
  return (
    <ColorSlider
      stops={values}
      ref={ref || fallbackRef}
      value={value}
      trackStyles={trackStyles}
      thumbStyles={thumbStyles}
      {...rest}
    />
  )
})

VolumeSlider.propTypes = {
  value: PropTypes.number
}

export default VolumeSlider
